import { useQuery } from "@tanstack/react-query";
import React, { useEffect, useState } from "react";
import { getUserSession } from "../services/getUserSession";
import { QueryKeys } from "../services/types";
import TopNavigation from "../components/molecules/TopNavigation/TopNavigation";
import BottomNavigation, {
  Pathnames,
} from "../components/molecules/BottomNavigation";
import { Outlet, useNavigate } from "react-router-dom";
import { Link } from "../database.types";
import { Session } from "@supabase/supabase-js";

export type OutletContextProps = [
  Session | null,
  number,
  (page: number) => void,
  Link[],
  (links: Link[]) => void,
  number | null | undefined,
  (activeTagId: number | null) => void
];

export enum SelectedView {
  MY_LINKS = "myLinks",
  LIKED_LINKS = "likedLinks",
}

const storagePage = sessionStorage.getItem("page")
  ? Number(sessionStorage.getItem("page"))
  : 0;

const Layout = () => {
  const { data: session } = useQuery({
    queryFn: getUserSession,
    queryKey: [QueryKeys.SESSION],
  });
  const [page, setPage] = useState<number>(storagePage);
  const [links, setLinks] = useState<Link[]>([]);
  const [activeTagId, setActiveTagId] = useState<number | null | undefined>(
    undefined
  );

  const navigate = useNavigate();

  const handleChangePage = (page: number) => {
    sessionStorage.setItem("page", page.toString());
    setPage(page);
  };

  useEffect(() => {
    if (!session) {
      navigate(Pathnames.AUTH);
    }
  }, [navigate, session]);

  return (
    <>
      {session?.user?.user_metadata?.username && (
        <TopNavigation session={session} />
      )}
      <Outlet
        context={[
          session,
          page,
          handleChangePage,
          links,
          setLinks,
          activeTagId,
          setActiveTagId,
        ]}
      />
      {session?.user?.user_metadata?.username && <BottomNavigation />}
    </>
  );
};

export default Layout;
